<template>
  <b-modal :id="modalId" hide-footer no-close-on-backdrop size="lg">
    <div class="eula-modal-card">
      <eula />
    </div>
  </b-modal>
</template>

<script>
import Eula from '../Eula.vue';
import config from '../../constants/config';

export default {
  name: 'EulaModal',
  components: {
    Eula
  },
  computed: {
    modalId() {
      return config.EULA_MODAL_ID;
    }
  }
};
</script>

<style scoped>
.eula-modal-card .card {
  box-shadow: none;
}
</style>
